export const PromotionRewardTarget = {
  Bonus: 'Bonus',
  Cash: 'Cash',
  FreeSpins: 'FreeSpins',
  Coins: 'Coins',
  InstantWheel: 'InstantWheel',
  BonanzaPoints: 'BonanzaPoints',
  Wheel: 'Wheel',
  Scratcher: 'Scratcher',
};
